import { FormControlLabel, Switch, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="start" />
			<Text semiBold text="end" />
			<FormControlLabel
				control={<Switch checked={false} />}
				label="Start Label"
				labelPlacement="start"
			/>
			<FormControlLabel
				control={<Switch checked />}
				label="End Label"
				labelPlacement="end"
			/>
		</CssColumnGrid>
	);
};
